import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Query } from 'react-apollo';
import { Spin } from 'antd';
import { getCurrencyFormattedValue, monthsShortCodes } from '../../utils/globals';

import EdlApplicationByIdQuery from '../../graphql/queries/edlApplicationByIdQuery.graphql';

const cobRelationshipOptions = [
  { name: 'Father', value: 'father' },
  { name: 'Mother', value: 'mother' },
  { name: 'Brother', value: 'brother' },
  { name: 'Sister', value: 'sister' },
  { name: 'Spouse', value: 'spouse' },
  { name: 'Cousin', value: 'cousin' },
  { name: 'Paternal Uncle (Chacha)', value: 'paternalUncle' },
  { name: 'Paternal Aunt (Chachi)', value: 'paternalAunt' },
  { name: 'Maternal Uncle (Mama)', value: 'maternalUncle' },
  { name: 'Maternal Aunt (Mami)', value: 'maternalAunt' },
  { name: 'Relative', value: 'relative' },
];

const professionOptions = [
  { name: 'Salaried - Pvt Ltd/Partnership', value: 'salariedPrivate' },
  { name: 'Salaried - Govt/Pul Ltd/Pub sector', value: 'salariedPublic' },
  { name: 'Salaried - MNC', value: 'salariedMnc' },
  { name: 'Self Emp - Partnership/Proprietorship', value: 'selfEmpPropPartner' },
  { name: 'Self Emp - Pvt Ltd', value: 'selfEmpPvtLtd' },
  { name: 'Farmer', value: 'farmer' },
  { name: 'Retired', value: 'retired' },
  { name: 'Other', value: 'other' },
];

const collateralOptions = [
  { name: 'Flat', value: 'flat' },
  { name: 'House', value: 'house' },
  { name: 'Non-Agricultural Land', value: 'naLand' },
  { name: 'FD', value: 'fd' },
];

const EdlApplicationPage = ({
  match: {
    params: { id },
  },
}) => (
  <Query variables={{ id }} query={EdlApplicationByIdQuery} fetchPolicy="network-only">
    {({ loading, error, data }) => {
      if (loading) return <Spin />;
      if (error) return `Error! ${error.message}`;

      const { loanApplication } = data;
      return (
        <div className="contentBox">
          <h1>Loan Application Details</h1>
          <table id="loanApplnDetailsTable">
            <tbody>
              <tr>
                <th>Key</th>
                <td>{loanApplication.key}</td>
              </tr>
              <tr className="loanApplnDetailsTableSectionHeaderRow">
                <th colSpan={2}>Applicant</th>
              </tr>
              <tr>
                <th>Name</th>
                <td>
                  {loanApplication.firstName} {loanApplication.lastName}
                </td>
              </tr>
              <tr>
                <th>Address</th>
                <td>
                  {loanApplication.currentAddress.streetAddress}
                  <br />
                  {loanApplication.currentAddress.city}, {loanApplication.currentAddress.state} -{' '}
                  {loanApplication.currentAddress.pincode}
                </td>
              </tr>
              <tr>
                <th>Mobile</th>
                <td>+91 {loanApplication.mobile}</td>
              </tr>
              <tr>
                <th>Email</th>
                <td>{loanApplication.email}</td>
              </tr>
              <tr>
                <th>Last College</th>
                <td>{loanApplication.lastCollege}</td>
              </tr>
              <tr>
                <th>Last Course</th>
                <td>{loanApplication.lastCourse}</td>
              </tr>
              <tr>
                <th>Last Course Marks</th>
                <td>{loanApplication.lastCourseMarksPercent} %</td>
              </tr>
              <tr className="loanApplnDetailsTableSectionHeaderRow">
                <th colSpan={2}>Loan Applied for College</th>
              </tr>
              <tr>
                <th>Name</th>
                <td>{loanApplication.college.name}</td>
              </tr>
              <tr>
                <th>Address</th>
                <td>
                  {loanApplication.college.address}
                  <br />
                  {loanApplication.college.city}, {loanApplication.college.state} - {loanApplication.college.pincode}
                </td>
              </tr>
              <tr>
                <th>Course</th>
                <td>
                  {loanApplication.course.name} ({loanApplication.course.durationYears})
                </td>
              </tr>
              <tr className="loanApplnDetailsTableSectionHeaderRow">
                <th colSpan={2}>Loan Information</th>
              </tr>
              <tr>
                <th>Loan Amount</th>
                <td>{getCurrencyFormattedValue(loanApplication.loanAmount)}</td>
              </tr>
              <tr>
                <th>Loan Required By</th>
                <td>
                  {monthsShortCodes[loanApplication.loanRequiredMonth]} {loanApplication.loanRequiredYear}
                </td>
              </tr>
              <tr className="loanApplnDetailsTableSectionHeaderRow">
                <th colSpan={2}>Co-borrower Details</th>
              </tr>
              <tr>
                <th>Relationship with the applicant</th>
                <td>{cobRelationshipOptions.find((entry) => entry.value === loanApplication.cobRelationship).name}</td>
              </tr>
              <tr>
                <th>Name</th>
                <td>
                  {loanApplication.cobFirstName} {loanApplication.cobLastName}
                </td>
              </tr>
              <tr>
                <th>Address</th>
                <td>
                  {loanApplication.cobCurrentAddress.streetAddress}
                  <br />
                  {loanApplication.cobCurrentAddress.city}, {loanApplication.cobCurrentAddress.state} -{' '}
                  {loanApplication.cobCurrentAddress.pincode}
                </td>
              </tr>
              <tr>
                <th>Date of Birth</th>
                <td>{loanApplication.cobDob}</td>
              </tr>
              <tr>
                <th>Email</th>
                <td>{loanApplication.cobEmail}</td>
              </tr>
              <tr>
                <th>Mobile</th>
                <td>+91 {loanApplication.mobile}</td>
              </tr>
              <tr>
                <th>Landline</th>
                <td>{loanApplication.cobLandline}</td>
              </tr>
              <tr>
                <th>Profession</th>
                <td>{professionOptions.find((entry) => entry.value === loanApplication.cobProfession).name}</td>
              </tr>
              <tr>
                <th>Designation</th>
                <td>{loanApplication.cobDesignation}</td>
              </tr>
              <tr>
                <th>Name of employer / company</th>
                <td>{loanApplication.cobCompanyName}</td>
              </tr>
              <tr>
                <th>Net monthly income</th>
                <td>{getCurrencyFormattedValue(loanApplication.cobMonthlyIncome)}</td>
              </tr>
              <tr className="loanApplnDetailsTableSectionHeaderRow">
                <th colSpan={2}>Collateral Details</th>
              </tr>
              <tr>
                <th>Collateral Offered?</th>
                <td>{loanApplication.collateralOffered ? 'Yes' : 'No'}</td>
              </tr>
              {loanApplication.collateralOffered ? (
                <Fragment>
                  <tr>
                    <th>Type</th>
                    <td>{collateralOptions.find((entry) => entry.value === loanApplication.collateralType).name}</td>
                  </tr>
                  <tr>
                    <th>Market Value</th>
                    <td>{getCurrencyFormattedValue(loanApplication.collateralMarketValue)}</td>
                  </tr>
                  <tr>
                    <th>Location</th>
                    <td>
                      {loanApplication.collateralLocationCity}, {loanApplication.collateralLocationState}
                    </td>
                  </tr>
                </Fragment>
              ) : null}
              <tr className="loanApplnDetailsTableSectionHeaderRow">
                <th colSpan={2}>Additional Information</th>
              </tr>
              <tr>
                <th>Additional Information</th>
                <td>{loanApplication.additionalInformation}</td>
              </tr>
            </tbody>
          </table>
        </div>
      );
    }}
  </Query>
);

EdlApplicationPage.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
};

export default EdlApplicationPage;



// WEBPACK FOOTER //
// ./src/pages/edl/EdlApplicationPage.jsx